import React from "react";

import { Terminal } from "@formant/ui-kit";

interface ICommandTemplateToolbarProps {
    commandCount: number;
}

export const CommandTemplateToolbar: React.FC<ICommandTemplateToolbarProps> = ({
    commandCount,
}) => {
    return (
        <div className="flex items-center gap-2 p-4 bg-slate-800">
            <Terminal className="h-5 w-5 text-slate-400" />
            <span className="text-2xl font-bold">{commandCount}</span>
            <span className="text-slate-400">Commands</span>
        </div>
    );
};
